import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { getTournamentListApi } from "./TournamentController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";

function TournamentsEvents() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.language);

  const [tournamentList, setTournamentList] = useState([]);

  console.log("tournamentListtournamentListtournamentList", tournamentList);

  useEffect(() => {
    getTournamentList();
  }, []);

  const getTournamentList = () => {
    try {
      dispatch(loaderStateTrue());
      getTournamentListApi()
        .then((response) => {
          let responseData = response.data || [];
          if (responseData.length > 0) {
            responseData = responseData.map((item) => {
              return {
                ...item,
                value: item?.name || "",
                label: item?.name || "",
                id: item?._id || "",
              };
            });
          }
          setTournamentList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  const PrevArrow = ({ className, onClick }) => (
    <button
      className={`${className} !left-0 z-10`}
      onClick={onClick}
      type="button"
    >
      <img
        src="../../assets/images/icons/arrow-chevron-left.svg"
        alt="prev"
        className="w-6 h-6"
      />
    </button>
  );

  const NextArrow = ({ className, onClick }) => (
    <button
      className={`${className} !right-0 z-10`}
      onClick={onClick}
      type="button"
    >
      <img
        src="../../assets/images/icons/arrow-chevron-right.svg"
        alt="next"
        className="w-6 h-6"
      />
    </button>
  );

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const ongoingTournaments = [
    {
      id: 1,
      teamImage: "assets/images/club-players/paris.png",
      leagueLogo: "assets/images/clubs/ligue1.png",
      title: "rencontres de ligue 1",
      bgColor: "#085EFF",
      skewColor: "#3D54AC",
      gradientFrom: "#3D54AC",
    },
    {
      id: 2,
      teamImage: "assets/images/club-players/mesi.png",
      leagueLogo: "assets/images/clubs/fiffa.png",
      title: "rendez-vous internationaux",
      bgColor: "#F8F8F8",
      skewColor: "#F8F8F8",
      gradientFrom: "#1e1e1e",
    },
    {
      id: 3,
      teamImage: "assets/images/club-players/laliga.png",
      leagueLogo: "assets/images/clubs/laliga.png",
      title: "rendez-vous internationaux",
      bgColor: "#FF4B44",
      skewColor: "#FF4B44",
      gradientFrom: "#DC4039",
    },
    {
      id: 4,
      teamImage: "assets/images/club-players/a-player.png",
      leagueLogo: "assets/images/clubs/a-club.png",
      title: "rendez-vous internationaux",
      bgColor: "#002D72",
      skewColor: "#002D72",
      gradientFrom: "#002D72",
    },
  ];

  const upcomingTournaments = [
    {
      id: 1,
      teamImage: "assets/images/club-players/paris.png",
      leagueLogo: "assets/images/clubs/ligue1.png",
      title: "rencontres de ligue 1",
      bgColor: "#085EFF",
      skewColor: "#3D54AC",
      gradientFrom: "#3D54AC",
    },
    {
      id: 2,
      teamImage: "assets/images/club-players/mesi.png",
      leagueLogo: "assets/images/clubs/fiffa.png",
      title: "rendez-vous internationaux",
      bgColor: "#F8F8F8",
      skewColor: "#F8F8F8",
      gradientFrom: "#1e1e1e",
    },
  ];

  return (
    <main class="main p-4 relative">
      <div class="flex flex-wrap items-start gap-y-6 -mx-2">
        <div class="lg:w-4/6 w-full px-2">
          <div class="space-y-8">
            <div class="space-y-6">
              <div class="flex items-center gap-3">
                <h3 class="xl:text-2xl text-xl font-extrabold uppercase">
                  ongoing tournaments & events
                </h3>
                <p class="ml-auto font-semibold text-gray-400">
                  {ongoingTournaments.length} ongoing tournaments
                </p>
              </div>

              <div class="">
                <div class="flex flex-wrap -mx-2 gap-y-8">
                  {ongoingTournaments.map((team, index) => (
                    <div key={index} className="xs:w-1/2 w-full px-2">
                      <div
                        className="relative"
                        onClick={() =>
                          navigate(
                            `/${language}/tournaments-events/${team._id}`
                          )
                        }
                      >
                        {/* Background Layer */}
                        <div
                          className="rounded-xl absolute inset-0 overflow-hidden"
                          style={{ backgroundColor: team.bgColor }}
                        >
                          <div
                            className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/40"
                            style={{ backgroundColor: team.skewColor }}
                          ></div>
                        </div>

                        {/* Main Content */}
                        <div className="relative bg-cover bg-no-repeat bg-center h-full">
                          <div className="flex lg:justify-end justify-end max-sm:flex-wrap gap-y-3 w-full">
                            <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                              <img
                                src={team.teamImage}
                                alt=""
                                className="max-w-full lg:max-h-[276px] inline-block"
                              />
                            </div>
                          </div>

                          {/* Gradient Section */}
                          <div
                            className="absolute inset-0 p-4 flex flex-col justify-between items-start gap-6 rounded-b-xl overflow-hidden"
                            style={{
                              background: `linear-gradient(to top, ${team.gradientFrom}, transparent)`,
                            }}
                          >
                            <img src={team.leagueLogo} alt="" />

                            <div className="space-y-2 sm:w-4/5 w-full">
                              <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">
                                {team.title}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div class="space-y-6">
              <div class="flex items-center gap-3">
                <h3 class="xl:text-2xl text-xl font-extrabold uppercase">
                  Upcoming tournaments & events
                </h3>
                <p class="ml-auto font-semibold text-gray-400">
                  {tournamentList.length} upcoming tournaments
                </p>
              </div>

              <div class="">
                <div class="flex flex-wrap -mx-2 gap-y-8">
                  {tournamentList.map((team, index) => (
                    <div
                      key={index}
                      className="xs:w-1/2 w-full px-2"
                      onClick={() =>
                        navigate(`/${language}/tournaments-events/${team._id}`)
                      }
                    >
                      {team.name}
                      <div className="relative">
                        {/* Background Layer */}
                        <div
                          className="rounded-xl absolute inset-0 overflow-hidden"
                          style={{ backgroundColor: team.bannerImage }}
                        >
                          <div
                            className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/40"
                            style={{ backgroundColor: team.skewColor }}
                          ></div>
                        </div>

                        {/* Main Content */}
                        <div className="relative bg-cover bg-no-repeat bg-center h-full">
                          <div className="flex lg:justify-end justify-end max-sm:flex-wrap gap-y-3 w-full">
                            <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                              <img
                                src={team.bannerImage}
                                alt=""
                                className="max-w-full lg:max-h-[276px] inline-block"
                              />
                            </div>
                          </div>

                          {/* Gradient Section */}
                          <div
                            className="absolute inset-0 p-4 flex flex-col justify-between items-start gap-6 rounded-b-xl overflow-hidden"
                            style={{
                              background: `linear-gradient(to top, ${team.gradientFrom}, transparent)`,
                            }}
                          >
                            <img src={team.leagueLogo} alt="" />

                            <div className="space-y-2 sm:w-4/5 w-full">
                              <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">
                                {team.name}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:w-2/6 w-full px-2 sticky top-20">
          <div class="space-y-5">
            <div class="relative rounded-xl overflow-hidden">
              <div class="rounded-xl absolute inset-0 bg-[#F5F5F5] overflow-hidden">
                <div class="w-[15vw] h-[15vw] rounded-[50%] bg-[#F022AC] blur-[50px] absolute -top-[8vw] -left-10 opacity-50"></div>
                <div class="w-[20vw] h-[20vw] rounded-[50%] bg-[#FB4A4A] blur-[50px] absolute -top-[5vw] -right-20"></div>
              </div>
              <div class="relative bg-cover bg-no-repeat bg-center h-full">
                <div class="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                  <div class="flex-none max-sm:w-1/2 max-lg:w-1/3 relative">
                    <img
                      src="assets/images/football-stadium.png"
                      alt=""
                      class="max-w-full lg:max-h-[276px] inline-block"
                    />
                  </div>
                </div>
                <div class="p-4 flex flex-col justify-between gap-6">
                  <div class="space-y-2">
                    <h4 class="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase">
                      Create a new Tournament
                    </h4>
                    <p class="font-secondary font-semibold text-gray-400">
                      Lorem Ipsum is simply dummy text.
                    </p>
                  </div>
                  <div
                    class=""
                    onClick={() => navigate(`/${language}/create-tournament`)}
                  >
                    <button class="btn btn-primary text-nowrap ml-auto">
                      {t("seeAll")}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel space-y-3">
              <div class="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                <div class="flex justify-center gap-3 w-full">
                  {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button> */}
                  <h3 class="xl:text-lg text-base font-extrabold uppercase">
                    {t("currentlyPlaying")}
                  </h3>
                  {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button> */}
                </div>
              </div>
              <div class="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
                <Slider {...settings}>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">
                        30 August 2025
                      </h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/paris.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">
                          12:15
                        </div>
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/sb29.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("france")}
                      </div>
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("spain")}
                      </div>
                    </div>
                  </div>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">
                        30 August 2025
                      </h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/sb29.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">
                          12:15
                        </div>
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/rcl.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("france")}
                      </div>
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("spain")}
                      </div>
                    </div>
                  </div>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">
                        30 August 2025
                      </h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/paris.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">
                          12:15
                        </div>
                        <div class="flex-none w-16">
                          <img
                            src={require("../../assets/images/clubs/sb29.png")}
                            alt=""
                            class="h-24 object-contain"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("france")}
                      </div>
                      <div class="font-secondary text-lg font-bold uppercase">
                        {t("spain")}
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default TournamentsEvents;
